import { clearToken } from "./session";

export async function logout() {
  // Se você tiver endpoint no backend, pode chamar aqui.
  // try { await api.post("/api/auth/logout"); } catch {}
  clearToken();
}
